import { IAbcComponent } from '../abcComponent.model';
export interface IListBox extends IAbcComponent {
  width?: string;
  height?: string;
  activeStateEnabled?: boolean;
  allowItemDeleting?: boolean;
  bounceEnabled?: boolean;
  collapsibleGroups?: boolean;
  focusStateEnabled?: boolean;
  alignItemLabels?: boolean;
  grouped?: boolean;
  hoverStateEnabled?: boolean;
  indicateLoading?: boolean;
  itemDeleteMode?: ItemDeleteMode;
  nextButtonText?: string;
  pageLoadingText?: string;
  showScrollbar?: ShowScrollbar;
  visible?: boolean;
  rtlEnabled?: boolean;
  repaintChangesOnly?: boolean;
  showSelectionControls?: boolean;
  selectionMode?: SelectionModeList;
  scrollingEnabled?: boolean;
  searchExpr?: string;
  searchValue?: string;
  searchMode?: SreachModeList;
}
export class AbcListBoxModel<T = {}> {
  id?: string;
  caption?: string;
  text?: string;
  badge?: string | number;
  checked?: boolean;
  name?: string;
  data?: T;
  disabled?: boolean;
  key?: string;
  items?: any | any[];
  group?: string;
  ImageSrc?: string;
}
export enum ItemDeleteMode {
  Context = 'context',
  SlideItem = 'slideItem',
  Static = 'static',
  Swipe = 'swipe',
  Toggle = 'toggle',
}

export enum ShowScrollbar {
  Always = 'always',
  Never = 'never',
  OnHover = 'onHover',
  OnScroll = 'OnScroll',
}

export enum SelectionModeList {
  All = 'all',
  Multiple = 'multiple',
  None = 'none',
  Single = 'single',
}

export enum SreachModeList {
  Contains = 'contains',
  Startswith = 'startswith',
  Equals = 'equals',
}

export declare type SearchMode = 'contains' | 'startswith' | 'equals';
